import { CALL_API, getJSON } from 'redux-api-middleware'
import path from 'path'
import queryString from 'query-string'
import compact from 'lodash/compact'
import merge from 'lodash/merge'

export const API_ENDPOINT = `${process.env.API_ENDPOINT}`

import humps from 'humps'
import { arrayOf } from 'normalizr'
import objectToFormData from 'object-to-formdata'

import deserialize from '../helpers/deserialize'

export function fetchCollection ({ schema, ...options }) {
  return fetchResource({
    schema: arrayOf(schema),
    ...options
  })
}

export function fetchResource (options) {
  return baseRequest({
    method: 'GET',
    ...options
  })
}

export function createResource ({ data, key, baseParams, ...options }) {
  var body = null
  if (data) {
    body = { [key]: data, ...baseParams }
  }

  return baseRequest({
    method: 'POST',
    body,
    key,
    ...options
  })
}

export function updateResource ({ data, key, baseParams, ...options }) {
  var body = null
  if (data) {
    body = { [key]: data, ...baseParams }
  }

  return baseRequest({
    method: 'PATCH',
    body,
    key,
    ...options
  })
}

export function deleteResource (options) {
  return baseRequest({
    method: 'DELETE',
    ...options
  })
}

export function performActionOnResource ({ url, action, ...options }) {
  return baseRequest({
    method: 'POST',
    url: path.join(url, action),
    ...options
  })
}

export function baseRequest ({
  url,
  headers: headerOverrides,
  body,
  key,
  query,

  schema,
  actionPayload,

  binary,

  actions: [ request_action, success_action, failure_action ],

  sendAsFormData = false,
  authenticated = true,

  responseInterceptor = r => r,
  errorInterceptor = e => e,

  ...options
}) {
  return function (dispatch, getState) {
    var headers = {}

    if (query) {
      query = humps.decamelizeKeys(query)
      url = mergeQuery(url, query)
    }

    if (body) {
      body = humps.decamelizeKeys(body, { uncopyableTester })

      if (sendAsFormData) {
        body = objectToFormData(body)
      } else {
        headers['Content-Type'] = 'application/json'
        body = JSON.stringify(body)
      }
    }

    if (authenticated) {
      headers['X-Auth-Token'] = getState().auth.session.token || undefined
    }

    const request = {
      endpoint: `${API_ENDPOINT}${url}`,
      headers: {
        ...headers,
        ...headerOverrides
      },
      body,
      types: [request_action,
        {
          type: success_action,
          payload: (action, state, res) => {
            if (actionPayload) {
              return actionPayload
            } else if (key && schema) {
              return deserialize(res, key, schema).then((data) => responseInterceptor(data, res))
            } else if (binary) {
              return res.blob().then((blob) => responseInterceptor(blob, res) )
            } else {
              return getJSON(res).then((data) => responseInterceptor(data, res))
            }
          }
        }, {
          type: failure_action,
          payload: (action, state, res) => {
            if (errorInterceptor) return getJSON(res).then((data) => errorInterceptor(data, res))
            return getJSON(res).then((data) => {
              return {
                ...data,
                status: res.status
              }
            })
          },
          meta: (action, state, res) => {
            return {
              status: res.status,
              statusText: res.statusText
            }
          }
        }],
      ...options
    }

    return dispatch({ [CALL_API]: request })
  }
}

function uncopyableTester (object) {
  return object._isAMomentObject || toString.call(object) === '[object File]'
}

function mergeQuery (url, query) {
  let urlWithoutQuery = url

  if (url.split('?').length > 0) {
    urlWithoutQuery = url.split('?')[0]
  }

  const existingQuery = queryString.parse(queryString.extract(url))
  const newQueryString = queryString.stringify(
    merge({}, existingQuery, query), { arrayFormat: 'bracket' }
  )

  return `${urlWithoutQuery}?${newQueryString}`
}



// WEBPACK FOOTER //
// ./src/actions/index.js